/** Pure audio-to-motion math. The mouth follows Bash's own voice, band by band. */

export function rmsOf(buf: Float32Array): number {
  let sum = 0;
  for (let i = 0; i < buf.length; i++) sum += buf[i] * buf[i];
  return buf.length ? Math.sqrt(sum / buf.length) : 0;
}

/** Four mouth openings: shut, a little, talking, loud. */
export function bandFor(rms: number): 0 | 1 | 2 | 3 {
  if (rms < 0.015) return 0;
  if (rms < 0.05) return 1;
  if (rms < 0.12) return 2;
  return 3;
}

/** Fast attack so the mouth opens on the first syllable; slow release so it does not flicker between words. */
export function smooth(prev: number, next: number): number {
  return prev + (next - prev) * (next > prev ? 0.5 : 0.12);
}

export const SPEAK_ON = 0.02;
export const HANGOVER_MS = 250;

export interface SpeakingState {
  on: boolean;
  lastLoud: number;
}

/**
 * Speaking turns on the moment the level crosses SPEAK_ON and turns off only
 * once it has stayed under for HANGOVER_MS, so a breath between words is not
 * an edge. Returns the same object when nothing changed.
 */
export function speakingEdge(
  st: SpeakingState,
  rms: number,
  now: number
): SpeakingState {
  if (rms >= SPEAK_ON) return { on: true, lastLoud: now };
  if (st.on && now - st.lastLoud >= HANGOVER_MS)
    return { on: false, lastLoud: st.lastLoud };
  return st;
}
